import getRoomName from '../base/config/getRoomName';
import { downloadJSON } from '../base/util/downloadJSON';
/**
 * Create an action for saving the conference logs.
 *
 * @returns {Function}
 */
export function saveLogs() {
    return (dispatch, getState) => {
        var _a;
        const logs = (_a = getState()['features/base/connection'].connection) === null || _a === void 0 ? void 0 : _a.getLogs();
        const roomName = getRoomName() || '';
        downloadJSON(logs !== null && logs !== void 0 ? logs : {}, `meetlog-${roomName}.json`);
    };
}
